import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { CallController } from './CallController';

export const callStartOrJoin = defineCommand(
    'callStartOrJoin',
    'Call: Start Or Join',
    r => {
        const ctrl = r.call(CallController);
        ctrl.connect();
    }
);

export const callLeave = defineCommand(
    'callLeave',
    'Call: Leave',
    r => {
        const ctrl = r.call(CallController);
        ctrl.disconnect();
    }
);
